import { useApiClient } from "@/modules/api/apiClient.store.ts";
import type { PaymentParams, PaymentProps } from "@/modules/billing/payment/PaymentParams";
import {
    checkForPaymentTargetSuccess,
    getRedirectUrlFromData,
    linkSendData,
    redirectToGatewayAndWaitForResponse,
} from "@/modules/billing/payment/paymentUtils.ts";
import { t_StartingPayment } from "@/modules/billing/progressLabels.tsx";
import { useUnmountSignal } from "@/utils/react/useUnmountSignal.tsx";
import type { DuitkuRedirectSendDataResponse, MethodConfig, ProcessorConfig } from "@warrenio/api-spec/spec.oats.gen";
import { useImperativeHandle } from "react";
import invariant from "tiny-invariant";

export default function DuitkuPaymentForm({
    actionsRef,
    method: { key },
}: { config: ProcessorConfig & { type: "link" }; method: MethodConfig } & PaymentProps) {
    //#region Hooks

    const apiClient = useApiClient();
    const signal = useUnmountSignal();

    useImperativeHandle(actionsRef, () => ({
        needsPopUp(_params) {
            return true;
        },

        async makePayment(params: PaymentParams) {
            const { progress, popup } = params;

            progress(t_StartingPayment);
            const { data } = await linkSendData<DuitkuRedirectSendDataResponse>(apiClient, params, "duitku", {
                paymentMethod: key,
            });

            invariant(
                "link_response" in data && "reference" in data.link_response,
                "Expected reference in link_response",
            );
            const {
                link_response: { reference },
            } = data;

            return await redirectToGatewayAndWaitForResponse({
                popup,
                progress,
                redirectUrl: getRedirectUrlFromData(data),
                signal,
                check: async () =>
                    await checkForPaymentTargetSuccess({
                        apiClient,
                        reference: `duitku::${reference}`,
                        params,
                        signal,
                    }),
            });

            // TODO: Handle return: "?merchantOrderId=1724409970073146&resultCode=00&reference=D589424JR13SC0163ME110"
        },
    }));
    //#endregion

    return null;
}
